export default __webpack_public_path__ + "static/media/userUmbrella.f62af18e.svg";